import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Carlist.css';
import { FaCamera } from "react-icons/fa";
import { IoSpeedometer } from "react-icons/io5";
import { MdDateRange } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { GiGearStickPattern } from "react-icons/gi";
import CarFilter from './CarFiiltercomp'; // Adjusted import to match the correct filename
import  useCarFilter from './UseCarFilter'; // Updated to useCarFilter
import { imagesWithText } from '../Home Page/HomePage';
import Carousel from '../Carousel/Carousel';
import CarSlideshow from './CarSlideShow';

const CarListReview = () => {
  const navigate = useNavigate(); // Initialize useNavigate at the top level

  const [carList, setCarList] = useState([]); // State to store fetched car details
  const [loading, setLoading] = useState(true); // Manage loading state

  // Use the car filter context values
  const {
    carMakes,
    carModels,
    carVariants,
    carColors,
    selectedMake,
    selectedModel,
    selectedVariant,
    selectedColor,
    handleMakeChange,
    handleModelChange,
    handleVariantChange,
    setSelectedColor,
  } = useCarFilter(); // Custom hook to handle car filtering logic

  const handleListUpdate = async (carId) => {
    try {
      // Send a request to the backend to update the car's listNo property to "yes"
      await axios.put(`https://zoomautos.co.uk/api/cars/${carId}`, { list: "yes" });
      console.log(`Car with ID ${carId} updated to list "yes"`);
  
      // Optionally, update the car list in the frontend to reflect the change
      setCarList((prevCarList) =>
        prevCarList.map((car) =>
          car._id === carId ? { ...car, list: "yes" } : car
        )
      );
    } catch (error) {
      console.error(`Error updating car with ID ${carId}:`, error);
    }
  };
  
  // Fetch car details from backend
  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/cars'); // Adjust API URL if needed
        const allCars = response.data;
        const filteredCars = allCars.filter(car => car.list === "no");
        setCarList(filteredCars);
      } catch (error) {
        console.error('Error fetching car details:', error);
      } finally {
        setLoading(false); // Stop loading state whether success or error
      }
    };

    fetchCars(); // Call fetch function when component mounts
  }, []); // Empty dependency array means it runs only once on mount

  const handleDeleteCar = async (carId) => {
    try {
      // Send a request to delete the car from the backend
      await axios.delete(`https://zoomautos.co.uk/api/cars/${carId}`);
      console.log(`Car with ID ${carId} has been deleted.`);
  
      // Remove the deleted car from the car list in the frontend
      setCarList((prevCarList) => prevCarList.filter((car) => car._id !== carId));
    } catch (error) {
      console.error(`Error deleting car with ID ${carId}:`, error);
    }
  };
  
  // Display loading state
  if (loading) {
    return <p>Loading cars...</p>;
  }

  // Check if carList is empty
  if (carList.length === 0) {
    return <p>No cars available.</p>;
  }

  // Filter the car list based on the selected make, model, color, and variant
  const filteredCars = carList.filter(car => {
    // If both make and color are selected, match both
    if (selectedMake && selectedColor) {
      return car.manufacturer === selectedMake && car.exteriorColor === selectedColor;
    }

    // If only color is selected, filter by color
    if (selectedColor) {
      return car.exteriorColor === selectedColor;
    }

    // If both make and model are selected, match both
    if (selectedMake && selectedModel) {
      return car.manufacturer === selectedMake && car.model === selectedModel;
    }

    // If only make is selected, filter by make
    if (selectedMake) {
      return car.manufacturer === selectedMake;
    }

    // If only model is selected, filter by model
    if (selectedModel) {
      return car.model === selectedModel;
    }

    // If variant is also selected along with make or model, filter by variant
    if (selectedVariant) {
      return (
        (!selectedMake || car.manufacturer === selectedMake) &&
        (!selectedModel || car.model === selectedModel) &&
        car.variant === selectedVariant
      );
    }

    // If none of the filters are selected, return all cars
    return true;
  });

  // This function will be called when a car box is clicked
  const handleCarClick = (car) => {
    console.log(car); // Check the car object in console
    navigate(`/Admin/AdminPortal/CarReview/Inventory/${car._id}`, { state: { car } });
  };

  // Image Gallery Component
  // Image Gallery Component
  const ImageGallery = ({ images }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  
    if (!Array.isArray(images) || images.length === 0) return null; // Return null if no images
  
    // Limit thumbnails to the first 5 images
    const thumbnailsToShow = images.slice(0, 5);
  
    return (
      <div className="images-gallery">
        {/* Main Image */}
        <div className="imagessss-overlay">
        <FaCamera className="icon" />
        <span>{images.length}</span>
      </div>
        <img src={images[selectedImageIndex]} alt="Car" className="main-image" />
        
        {/* Thumbnails */}
        <div className="thumbnail-container">
          {thumbnailsToShow.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Thumbnail ${index + 1}`}
              className="thumbnail"
              onMouseEnter={() => setSelectedImageIndex(index)} // Correct hover functionality
            />
          ))}
        </div>
      </div>
    );
  };
  
  return (
    <>
      <div className="carousel-container">
        <Carousel imagesWithText={imagesWithText} />
        <div className="overlay-text">
          <h1>Purchase Your Car</h1>
        </div>
      </div>
     
      <CarFilter
        carMakes={carMakes}
        carModels={carModels}
        carVariants={carVariants}
        carColors={carColors}
        selectedMake={selectedMake}
        selectedModel={selectedModel}
        selectedVariant={selectedVariant}
        selectedColor={selectedColor}
        handleMakeChange={handleMakeChange}
        handleModelChange={handleModelChange}
        handleVariantChange={handleVariantChange}
        setSelectedColor={setSelectedColor}
      />
      <div className='overall'>
        <div className='leftpane'>
          <h2>SELL YOUR VEHICLE</h2>
          <p>
            Interested in trading in your current vehicle? It would probably be good to have an estimate of what it’s worth first. After all, trading in a vehicle is a lot less hassle than selling it yourself.
          </p>
        </div>
        
        <div className="cars-container">
        {filteredCars.map((car) => (
  <div className="car-box" key={car._id} onClick={() => handleCarClick(car)}>
    <ImageGallery images={car.imagess} /> {/* Include the image gallery */}
    <div className="car-info-man">
      <h3 className="car-manufacturer">{car.manufacturer}</h3>
      <h4>{car.model}</h4>
      <h5>{car.variant}</h5>
      <h3>{car.attention}</h3>
      <div className="cars-infor">
        <div className="icon-text-container">
          <div className="icon-text">
            <GiGearStickPattern className="icon" />
            <h4>{car.transmission}</h4>
          </div>
        </div>
        <div className="icon-text-container">
          <div className="icon-text">
            <MdDateRange className="icon" />
            <h4>{car.year}</h4>
          </div>
        </div>
        <div className="icon-text-container">
          <div className="icon-text">
            <IoSpeedometer className="icon" />
            <h4>{car.mileage}</h4>
          </div>
        </div>
      </div>
      {/* Add a button to update listNo */}
      <div style={{flexDirection:'row', gap:'20px'}}>
      <button
        className="contact-button"
        onClick={(e) => {
          e.stopPropagation(); // Prevent triggering the car click
          handleListUpdate(car._id);
        }}
      >
        Update List to Yes
      </button>
      {/* Add a button to delete car */}
      <button
        className="contact-button"
        onClick={(e) => {
          e.stopPropagation(); // Prevent triggering the car click
          handleDeleteCar(car._id);
        }}
      >
        Delete Car
      </button>
      </div>
    </div>
  </div>
))}


        </div>
      </div>
      
    </>
  );
};

export default CarListReview;
